import {multiFormToJson, onMultiCalcPriceChange, fieldPrefix} from './multi-common'

let priceChangeObservers = [];

function subscribe(func) {
    priceChangeObservers.push(func);
}

function unsubscribe(func) {
    priceChangeObservers = priceChangeObservers.filter((observer) => observer !== func);
}

const DP_I18N = {
    months: ['styczeń', 'luty', 'marzec', 'kwiecień', 'maj', 'czerwiec', 'lipiec', 'sierpień', 'wrzesień', 'październik', 'listopad', 'grudzień'],
    monthsShort: ['sty', 'lut', 'mar', 'kwi', 'maj', 'cze', 'lip', 'sie', 'wrz', 'paź', 'lis', 'gru'],
    weekdays: ['niedziela', 'poniedziałek', 'wtorek', 'środa', 'czwartek', 'piątek', 'sobota'],
    weekdaysShort: [ 'niedz.', 'pn.', 'wt.', 'śr.', 'cz.', 'pt.', 'sob.' ],
    weekdaysAbbrev:	['Po','W','Ś','C','Pi','S', 'N'],
    cancel: 'Anuluj'
};
var priceTpl = '';

function calcPrice() {
    const form = $('form[data-trip-slug]');
    const multi = form.hasClass('multi-form');
    const tripSlug = form.attr('data-trip-slug');
    const data = multi ? multiFormToJson(form[0].elements) : formToJSON(form[0].elements);
    const waitingList = $('.rooms-row *[data-waiting-list="true"]').length > 0;
    if (!multi && !Array.isArray(data.turnIds)) {
        const turn = data.turnIds;
        data.turnIds = [];
        data.turnIds.push(turn);
    }
    if (!multi) {
        const custom = {};
        _.mapObject(_.pick(data, function(v, k) {
            return k.indexOf('custom[') >= 0;
        }), function(v, k) {
            custom[k.substring('custom['.length + 1, k.length - 2)] = v;
        });
        data.custom = custom;
    }

    $.ajax({
        url: "/" + tripSlug + "/price"  + (multi ? '/multi' : ''),
        type: 'POST',
        data: JSON.stringify(data),
        contentType:"application/json; charset=utf-8",
        dataType:"json",
    }).done(function(res) {
        const price = $(priceTpl)
        price.find('span[id]').text(res.price.toFixed(2));
        $('.enroll-price').html(
            waitingList ? '<p>Cena wyjazdu: <span id="the-price">zależna od dostępnego pokoju</span></p>' : price
        );

        $('.dynamic-addon').parent().hide();
        if (res.activeAddonIds != null) {
            res.activeAddonIds.forEach(function (id) {
                $('[name="addonIds"][value="' + id + '"]').each(function() {
                    if ($(this).attr('data-auto') === 'true') {
                        $(this).prop('checked', true);
                    }
                    $(this).closest('p').show();
                });
            });
        }

        if (multi) {
            onMultiCalcPriceChange(res, function(e) {
                toggleTrainingOptions(e);
            });
        }

        priceChangeObservers.forEach((observer) => observer(res));
    });
}

function toggleTrainingOptions(partCont) {
    partCont.find('.training-row').toggle(partCont.find('.training-addon:checked').length > 0);
}

function bindPriceChange() {
    $(document).on('change', '.price-mod', function() {
        calcPrice();
    });
    $('#sport').change(calcPrice);
}

function switchSkillOptions() {
    const sport = $('#sport').val();

    $('#participantSkill').find('option').each(function() {
        const id = $(this).val();
        $(this).text(sportStatuses.get(sport).get(id));
    });

    M.FormSelect.init($('#participantSkill'));
}

function bindSwitchSkillOptions() {
    $('#sport').change(switchSkillOptions);
}

function bindFvChange() {
    $('.fv-switch').change(function() {
        $('.fv-type-row').toggle($(this).is(':checked'));
        if ($(this).is(':checked')) {
            $('.fv-type-row select').change();
        } else {
            $('.fv-row').hide();
            $('.fv-address-row').hide();
        }
    });
    $('.fv-type-row select').change(function() {
        if ($(this).val() === '' || !$(this).closest('.fv-type-row').is(":visible")) {
            return;
        }

        $('#inv-ind').val($(this).val() === 'individual');
        $('.fv-row.' + $(this).val()).show();
        $('.fv-row:not(.' + $(this).val() + ')').hide();
        $('.fv-row:not(.' + $(this).val() + ') input').val('');
        $('.fv-address-row').show();
    });
}

function bindGenderAva() {
    $('#participantGender').change(function() {
        const male = $(this).val() === 'MALE';
        const female = $(this).val() === 'FEMALE';
        $.unique($('[data-boys], [data-girls]')).each(function() {
            const cont = $(this).closest('p');
            const shouldBlock = (male && $(this).attr('data-boys') === '0') ||
                (female && $(this).attr('data-girls') === '0');
            cont.find('input[type="checkbox"]').prop('disabled', shouldBlock);
            cont.find('.last-alert.tooltipped').toggle(!shouldBlock);
            cont.find('.gender-no-place').toggle(shouldBlock);
            if (shouldBlock && cont.find('input[type="checkbox"]').is(':checked')) {
                cont.find('input[type="checkbox"]').prop('checked', false);
            }
        });
    });
}

const datePickerSelectAddClass = function() {
    const self = this;
    setTimeout(function() {
        let selector = self.el;
        if (!selector) {
            selector = ".datepicker"
        }
        $(selector).siblings(".datepicker-modal") // modals are generated alongside each date picker
            .find(".select-dropdown.dropdown-trigger") // the .dropdown-trigger element is the trigger for the <selects> to appear
            .each((index, item) => {
                const dateDropdownID = $(item).attr("data-target"); // now we've got the ID of one of the generated <ul> elements
                const dropdownULJQ = $(`#${dateDropdownID}`);
                // add an 'onclick' event handler
                dropdownULJQ.children("li").on("click",()=>{
                    datePickerSelectAddClass(); // yeah for some reason our UL elements get destroyed and recreated so we have to do this again.
                });
                dropdownULJQ.addClass("dropdown-content-datepicker") // add our own className to it so we can target it.
            });
    }, 500);
};

function initBirthDateDatepicker(elem) {
    const minYear = elem.attr('data-min-year') || '';
    const maxYear = elem.attr('data-max-year') || '';
    const start = (elem.attr('value') || '') !== '' ? new Date(elem.attr('value')) :
        (new Date(minYear === '' ? 2000 : parseInt(minYear), 0, 17));

    elem.datepicker({
        format: 'yyyy-mm-dd',
        yearRange: [minYear === '' ? 1940 : parseInt(minYear), maxYear === '' ? new Date().getFullYear() : parseInt(maxYear)],
        maxDate: maxYear === '' ? new Date() : new Date(parseInt(maxYear), 11, 31),
        showMonthAfterYear: true,
        changeMonth: true,
        changeYear: true,
        defaultDate: start,
        onOpen: datePickerSelectAddClass,
        i18n: DP_I18N
    });
}

function initPassportDatepicker(elem) {
    const start = (elem.attr('value') || '') !== '' ? new Date(elem.attr('value')) : new Date();

    elem.datepicker({
        format: 'yyyy-mm-dd',
        showMonthAfterYear: true,
        changeMonth: true,
        changeYear: true,
        defaultDate: start,
        onOpen: datePickerSelectAddClass,
        i18n: DP_I18N
    });
}

function enableWaitingList(turnCont) {
    $('.turns-select > p').not(turnCont).hide();
    $('[name="turnIds"]').prop('checked', false);
    $('[name="waitingListMode"]').val(true);
    turnCont.find('.last-alert').not('.tooltipped').toggle();
    turnCont.find('[name="turnIds"]')
        .prop('disabled', false)
        .prop('checked', true)
        .attr('onclick', 'return false;');
}

function disableWaitingList(turnCont) {
    turnCont.find('.last-alert').not('.tooltipped').toggle();
    $('[name="waitingListMode"]').val(false);
    $('.turns-select > p').show();
    turnCont.find('[name="turnIds"]')
        .prop('disabled', true)
        .prop('checked', false);
}

function bindWaitingList() {
    $(document).on( 'click', '.waiting-listmode-ena', function() {
        enableWaitingList($(this).closest('p'));
    });
    $(document).on( 'click', '.waiting-listmode-disa', function() {
        disableWaitingList($(this).closest('p'));
    });

    if ($('[name="waitingListMode"]').val() === 'true') {
        enableWaitingList($('[name="turnIds"]:checked').closest('p'));
    }
}

function bindEquipmentRow() {
    const multi = $('form[data-trip-slug]').hasClass('multi-form');

    if (!multi) {
        $('[name*="equipmentRent"]').change(function () {
            $('.equipment-data-row').toggle($(this).val() !== '');
        })
    }
    $(document).on('change', '[name*="equipmentRent"]', function() {
       $(this).closest('.part-section').find('.equipment-data-row').toggle($(this).val() !== '');
    });
}

function showRoomTypes() {
    const form = $('form[data-trip-slug]');
    const tripSlug = form.attr('data-trip-slug');
    const currency = form.attr('data-trip-currency') || 'zł';

    const turnId = $('input[name="turnId"]:checked').val() || $('#turnId').val();
    if (turnId === undefined) {
        return;
    }

    const data = {
        turnId: parseInt(turnId),
        adultCount: parseInt($('#adultCount').val()),
        youngCount: parseInt($('#youngCount').val()),
        childCount: parseInt($('#childCount').val())
    };

    if (data.adultCount === 0 && data.youngCount === 0) {
        return;
    }

    $.ajax({
        url: "/" + tripSlug + "/rooms/free",
        type: 'POST',
        data: JSON.stringify(data),
        contentType: "application/json; charset=utf-8",
        dataType: "json",
    }).done(function(res) {
        $('.room-types-cont').empty();
        if (res.length === 0) {
            return;
        }
        res.forEach(function(type) {
            const clone = $('.room-type-tpl').clone();
            clone.removeClass('room-type-tpl');
            clone.find('.room-type').attr({ 'data-id': type.id,
                'data-name': type.name, 'data-max': type.numberOfPeopleMax,
                'data-waiting-list': type.waitingList });
            clone.find('.card-title').text(type.name);
            clone.find('.card-content p').text(type.description);
            if (type.waitingList) {
                clone.find('.price-cont')
                    .text('Cena: zależna od dostępnego pokoju');
            } else {
                clone.find('.price-cont')
                    .text('Cena: ' + type.price + ' ' + currency);
            }
            $('.room-types-cont').append(clone);
        })
    });
}

function bindCounters() {
    $('.counter a').click(function() {
        const field = $(this).closest('.counter').find('input');
        const step = $(this).hasClass('counter-add') ? 1 : -1;
        const curVal = parseInt(field.val());
        if (step === -1 && curVal === 0) {
            return;
        }
        field.val(curVal + step).change();
    });
    $('.counter input, input[name="turnId"]').change(function() {
        showRoomTypes();
    });
    $('.multi-form input[name="turnId"]').change(function() {
        $('.rooms-row').empty();
    });
}

function getFreeRoomsOfType(typeId, cb) {
    const form = $('form[data-trip-slug]');
    const tripSlug = form.attr('data-trip-slug');

    $.ajax({
        url: "/" + tripSlug + "/rooms/" + typeId + "/free",
        type: 'GET',
        contentType:"application/json; charset=utf-8",
        dataType:"json",
    }).done(function(res) {
        cb(res);
    });
}

function initRoomAdd() {
    $(document).on('click', '.room-add', function() {
        const roomTypeId = $(this).closest('.room-type').attr('data-id')
        const roomTypeName = $(this).closest('.room-type').attr('data-name')
        const roomTypeMax = $(this).closest('.room-type').attr('data-max')
        const waitingList = $(this).closest('.room-type').attr('data-waiting-list') === 'true';
        getFreeRoomsOfType(roomTypeId, function(freeRooms) {
            const ids = freeRooms.map(e => e.id)
            const alreadyInForm = $('.room-section').not('.room-tpl').map(function () {
                return parseInt($(this).attr('data-id'));
            }).get();
            let free = ids.filter(x => !alreadyInForm.includes(x));
            if (free.length > 0) {
                const roomId = free[0];
                const clone = $('.room-tpl').clone();
                clone.find('.card-title').text(roomTypeName);
                clone.removeClass('room-tpl');

                clone.attr({ 'data-id': roomId, 'data-type-id': roomTypeId,
                    'data-max': roomTypeMax, 'data-waiting-list': waitingList })
                $('.rooms-row').append(clone);
            }
        });
    });
}

function initParticipantAdd() {
    $(document).on('click', '.part-add', function() {
        const targetRoom = $(this).closest('.room-section');

        const clone = $('.part-tpl').clone();
        clone.removeClass('part-tpl');

        const ids = $('.part-section').not('.part-tpl').find('.sub-index').map(function() {
            return parseInt($(this).attr('value'));
        }).get();
        const targetIndex = ids.length === 0 ? 0 : (Math.max(...ids) + 1);

        clone.find('.sub-index').val(targetIndex);
        clone.find('.check-label [type="hidden"]').remove();
        clone.find('[name$="turnId"]').val($('.turns-select input:checked').val() || $('#turnId').val());

        clone.find('input, select').each(function() {
            const name = $(this).attr('name');
            if (name === undefined) {
                return;
            }

            const id = $(this).attr('id');
            const index = name.substring(fieldPrefix.length + 1, name.indexOf(']'));

            $(this).attr('name', name.replace('[' + index + ']', '[' + targetIndex + ']'));
            if (id !== undefined) {
                $(this).attr('id', id.replace(fieldPrefix + index, fieldPrefix + targetIndex));
            }
        });
        clone.find('label[for]').each(function() {
            const _for = $(this).attr('for');
            const index = _for.substring(fieldPrefix.length, _for.indexOf('.'));
            $(this).attr('for', _for.replace(fieldPrefix + index, fieldPrefix + targetIndex));
        });

        clone.find('.sub-roomTypeId').val(targetRoom.attr('data-type-id'));
        clone.find('.sub-roomId').val(targetRoom.attr('data-id'));

        initBirthDateDatepicker(clone.find('.datepicker'));
        initPassportDatepicker(clone.find('.pass-datepicker'));

        targetRoom.find('.part-cont').append(clone);
        clone.find('select').formSelect();

        calcPrice();
    });
}

function initExtraFields() {
    $(document).on('change', '.with-extra-field input[type="checkbox"]', function() {
        $(this).closest('.with-extra-field').find('.extra-field-row').toggle($(this).is(':checked'));
    });
}

function initFvCopy() {
    $('.fv-copy-address').change(function() {
        const ind = $('#fv-type').val() === 'true';
        if (ind) {
            $('#invoice\\.firstName').val($('#client\\.firstName').val())
                .closest('.input-field').find('label').toggleClass('active', true);
            $('#invoice\\.lastName').val($('#client\\.lastName').val())
                .closest('.input-field').find('label').toggleClass('active', true);
        }
        $('#invoice\\.street').val($('#client\\.street').val())
            .closest('.input-field').find('label').toggleClass('active', true);
        $('#invoice\\.postalCode').val($('#client\\.postalCode').val())
            .closest('.input-field').find('label').toggleClass('active', true);
        $('#invoice\\.city').val($('#client\\.city').val())
            .closest('.input-field').find('label').toggleClass('active', true);
    });
}

$(document).ready(function(){
    priceTpl = $('.enroll-price').html();
    $('form select').formSelect();

    $('.datepicker').each(function() {
        if ($(this).parents('.part-tpl').length > 0) {
            return;
        }

        initBirthDateDatepicker($(this));
    });
    $('.pass-datepicker').each(function() {
        if ($(this).parents('.part-tpl').length > 0) {
            return;
        }

        initPassportDatepicker($(this));
    });

    $(document).on('change', '.training-addon', function() {
        toggleTrainingOptions($(this).closest('.part-section'));
    });

    $('.part-section').each(function() {
        toggleTrainingOptions($(this));
    });

    bindSwitchSkillOptions();

    bindWaitingList();
    bindPriceChange();

    bindCounters();

    initExtraFields();
    initRoomAdd();
    initParticipantAdd();
    $(document).on('click', '.del-part', function() {
        $(this).closest('.part-section').remove();
        calcPrice();
    });
    $(document).on('click', '.room-remove', function() {
        $(this).closest('.room-section').remove();
        calcPrice();
    });
    initFvCopy();

    calcPrice();

    bindSwitchSkillOptions();
    switchSkillOptions();
    bindGenderAva();
    $('#participantGender').change();

    bindFvChange();
    $('.fv-switch').change();
    $('.fv-type-row select').change();

    $('.sel-all').change(function() {
        $('.consent input').prop('checked', $(this).is(':checked'));
    });
    $('.with-field input').change(function() {
        $(this).closest('p').find('.addon-field').toggle($(this).is(':checked'));
    });
    bindEquipmentRow();

    $('.tooltipped').tooltip();

    const turns = $('input[name="turnId"]');
    if (turns.length === 1) {
        turns.prop('checked', true);
    }
    showRoomTypes();
    $('form').submit(function( event ) {
            $(".submitbtn").prop("disabled", true).addClass("disabled");
        }
    )
});

export default subscribe;